module.exports = __webpack_public_path__ + "img/carrousel-flatpanel-3.c8708b1b.png";